<template>
    <div>
        <div class="favorite-coins mx-10">
            <!-- Filter Section -->
            <div class="filter-section">
                <!-- Row 1: Market Cap + FDV -->
                <div class="filter-row">
                    <div class="filter-group-pair">
                        <label>Market Cap (M):</label>
                        <div class="filter-input-pair">
                            <input v-model.number="filters.minMarketCap" type="number" placeholder="Min" class="filter-input" />
                            <input v-model.number="filters.maxMarketCap" type="number" placeholder="Max" class="filter-input" />
                        </div>
                    </div>
                    <div class="filter-group-pair">
                        <label>FDV (M):</label>
                        <div class="filter-input-pair">
                            <input v-model.number="filters.minFdv" type="number" placeholder="Min" class="filter-input" />
                            <input v-model.number="filters.maxFdv" type="number" placeholder="Max" class="filter-input" />
                        </div>
                    </div>
                </div>

                <!-- Row 2: Checkbox + Buttons -->
                <div class="filter-row">
                    <div class="filter-group-checkbox">
                        <label class="checkbox-label">
                            <input v-model="filters.isFutures" type="checkbox" class="filter-checkbox" />
                            <span>Futures</span>
                        </label>
                    </div>
                    <div class="filter-actions">
                        <button @click="applyFilters" class="apply-filter-btn">Search</button>
                        <button @click="resetFilters" class="reset-filter-btn">Reset</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import '@/assets/css/allcoins.css'
import '@/assets/css/binancealpha.css'

export default {
    name: "FavoriteBinanceAlpha",
    data() {
        return {
            filters: {
                minMarketCap: null,
                maxMarketCap: null,
                minFdv: null,
                maxFdv: null,
                sortBy: "symbol",
                order: "desc",
                isFutures: false
            }
        };
    },
    methods: {
        applyFilters() {
            const filtersToSend = {
                ...this.filters,
                minMarketCap: this.filters.minMarketCap ? this.filters.minMarketCap * 1000000 : null,
                maxMarketCap: this.filters.maxMarketCap ? this.filters.maxMarketCap * 1000000 : null,
                minFdv: this.filters.minFdv ? this.filters.minFdv * 1000000 : null,
                maxFdv: this.filters.maxFdv ? this.filters.maxFdv * 1000000 : null
            };
            this.$emit('apply-filters', filtersToSend);
        },

        resetFilters() {
            this.filters = {
                minMarketCap: null,
                maxMarketCap: null,
                minFdv: null,
                maxFdv: null,
                sortBy: "symbol",
                order: "desc",
                isFutures: false
            };
            this.$emit('reset-filters', this.filters);
        }
    }
};
</script>